import React from 'react';
import { CurrencyCircleDollar, MapPin, Phone, User } from '@phosphor-icons/react';

function formatCurrency(amount) {
  return `GHS ${amount.toLocaleString('en-GH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function TransportSection({ data }) {
  if (!data?.enrolled) {
    return (
      <div className="empty-state">
        <MapPin size={40} weight="light" />
        <h3>Not Enrolled in Transport</h3>
        <p>You are not currently enrolled in the transport service</p>
      </div>
    );
  }

  return (
    <div className="transport-section portal-section">
      {/* Transport Information Card */}
      <div className="section-header">
        <h2>
          <MapPin size={24} weight="duotone" />
          Transport Route Information
        </h2>
      </div>

      <div className="info-grid">
        <div className="info-card">
          <label>Route Name</label>
          <p className="info-value">{data.route_name}</p>
        </div>
        <div className="info-card">
          <label>Pickup Point</label>
          <p className="info-value">{data.pickup_point}</p>
        </div>
        <div className="info-card">
          <label>Dropoff Point</label>
          <p className="info-value">{data.dropoff_point}</p>
        </div>
        <div className="info-card">
          <label>Enrollment Date</label>
          <p className="info-value">{new Date(data.enrollment_date).toLocaleDateString()}</p>
        </div>
      </div>

      {/* Contact Information */}
      <div className="contact-section">
        <h3>Emergency Contact</h3>
        <div className="contact-grid">
          {data.emergency_contact && (
            <div className="contact-item">
              <User size={16} />
              <span>{data.emergency_contact}</span>
            </div>
          )}
          {data.emergency_contact_phone && (
            <div className="contact-item">
              <Phone size={16} />
              <span>{data.emergency_contact_phone}</span>
            </div>
          )}
        </div>
      </div>

      {/* Transport Fees Section */}
      <div className="fees-section">
        <h3>
          <CurrencyCircleDollar size={20} weight="duotone" />
          Transport Fee Status
        </h3>

        {data.recent_fees && data.recent_fees.length > 0 ? (
          <div className="fees-table-wrapper">
            <table className="fees-table">
              <thead>
                <tr>
                  <th>Fee Type</th>
                  <th>Due Date</th>
                  <th>Amount Due</th>
                  <th>Amount Paid</th>
                  <th>Balance</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.recent_fees.map(fee => (
                  <tr key={fee.id}>
                    <td className="fee-type">{fee.fee_type}</td>
                    <td>{fee.due_date ? new Date(fee.due_date).toLocaleDateString() : 'N/A'}</td>
                    <td className="amount-due">{formatCurrency(fee.amount_due)}</td>
                    <td className="amount-paid">{formatCurrency(fee.amount_paid)}</td>
                    <td className="balance">{formatCurrency(fee.balance)}</td>
                    <td>
                      <span className={`badge ${fee.is_paid ? 'success' : 'warning'}`}>
                        {fee.is_paid ? 'Paid' : 'Pending'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="empty-fees">
            <p>No fees recorded for transport</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TransportSection;
